module.exports = __webpack_public_path__ + "static/media/no_vol.d13f0c6d.png";